export default __webpack_public_path__ + "images/5c0fe4ffa42e7f33f42e094842e0c883.png";